import styled, { css } from 'styled-components'
import { EventType } from '../../types'

const eventTypeColors = {
  transaction: '#00ade6',
  sale: '#00b341',
  rental: '#7b61ff',
  permit: '#ff9500',
}

export const Container = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 32px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 8px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
  }
`

export const FilterPill = styled.button<{ $active: boolean; $type: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  color: #6b6b6b;
  position: relative;
  justify-content: center;
  font-family: inherit;

  &:hover {
    border-color: #999999;
    background: #f5f5f5;
  }

  ${({ $active, $type }) => {
    if (!$active) return ''

    const styles = {
      permit: `
        background: rgba(255, 149, 0, 0.1);
        border-color: #ff9500;
        color: #cc5500;
      `,
      transaction: `
        background: rgba(0, 173, 230, 0.1);
        border-color: #00ade6;
        color: #0099cc;
      `,
      rental: `
        background: rgba(128, 90, 213, 0.1);
        border-color: #7b61ff;
        color: #6b51e5;
      `,
      sale: `
        background: rgba(0, 179, 65, 0.1);
        border-color: #00b341;
        color: #00994d;
      `,
    }

    return styles[$type as keyof typeof styles] || ''
  }}
`

export const FilterIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 14px;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const FilterLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);

  @media (max-width: 768px) {
    font-size: 12px;
  }
`

export const FilterCount = styled.span.withConfig({
  shouldForwardProp: (prop) => !['active', 'eventType'].includes(prop),
})<{
  active: boolean
  eventType: EventType
}>`
  font-size: 12px;
  font-weight: 500;
  padding: 2px 6px;
  background: var(--bg-tertiary);
  border-radius: 10px;
  color: var(--text-secondary);

  ${({ active, eventType }) => {
    if (!active) return ''
    const color = eventTypeColors[eventType] || '#00ade6'
    return css`
      background: ${color};
      color: white;
    `
  }}
`
